import "babel-polyfill";

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store';
import MetaInfo from 'vue-meta-info'
import VueWechatTitle from 'vue-wechat-title';
// import { Button, Select, Form } from 'element-ui';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// import "swiper/dist/css/swiper.css";
import "./styles/index.scss";
import "./styles/_variables.scss";

import "swiper/dist/css/swiper.min.css"

// import '@/permission' // permission control

Vue.use(MetaInfo);
Vue.use(ElementUI);
Vue.use(VueWechatTitle);
Vue.prototype.$store = store;
Vue.config.productionTip = false

if (
	'-ms-scroll-limit' in document.documentElement.style &&
	'-ms-ime-align' in document.documentElement.style
) { // detect it's IE11
	window.addEventListener("hashchange", function (event) {
		var currentPath = window.location.hash.slice(1);
		if (store.state.route.path !== currentPath) {
			router.push(currentPath)
		}
	}, false)
}


/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	components: { App },
	template: '<App/>',
	// render: function (createElement) {
	// 	if ('-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style) {
	// 		window.addEventListener('hashchange', () => {
	// 			var currentPath = window.location.hash.slice(1)
	// 			if (this.$route.path !== currentPath) {
	// 				this.$router.push(currentPath)
	// 			}
	// 		}, false)
	// 	}
	// 	return createElement(Layout);
	// }
	mounted() {
		document.dispatchEvent(
			new Event("render-event")
		); /* //document.dispatchEvent(new Event('custom-render-trigger'))     这句非常重要，否则预渲染将不会启动 */
	}
})



// WEBPACK FOOTER //
// ./src/main.js